export default "__VITE_ASSET__BRkyOfO1__"